import React from 'react';
import { getStyles } from '../../../theme/styles';
import { Typography, Card, styled, Box } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { useCourseState } from '../../../context/CourseContext';
import ContentCourseDetails from '../Selectors/ContentCourseDetails';

const CourseInfoCard = styled(Card)(({ theme }) => ({
  background: '#fff',
  width: '100%',
  margin: `${theme.spacing(1)} ${theme.spacing(2)}`,
  minHeight: 175,
}));

interface CourseSetCardProps {
  className?: string;
  inPanel?: boolean;
}

export default function CourseSetCard({ className, inPanel }: CourseSetCardProps) {
  const theme = useTheme();
  const styles = getStyles(theme);
  const { courseSet } = useCourseState();

  return (
    <CourseInfoCard
      variant='outlined'
      className={className}
      sx={inPanel ? { margin: `${theme.spacing(1, 0)}`, boxSizing: 'border-box' } : undefined}
    >
      <Typography variant='h5' component='h5' sx={styles.customerCard_caption}>
        {courseSet?.name}
      </Typography>
      {courseSet?.courses && courseSet?.courses?.length > 0 && <Typography variant='h6' component='h6' sx={styles.customerCard_caption}>Courses:</Typography>}
      { courseSet?.courses && courseSet?.courses.map(course => (
          <Box key={course.courseId} sx={styles.customerCard_caption}>
            <ContentCourseDetails course={course}/>
          </Box>
      ))}
      { courseSet?.grades && <Typography variant='h6' component='h6' sx={styles.customerCard_caption}>Grades:</Typography>}
      { courseSet?.grades && <Typography key="grades" variant='body1' component='p' sx={styles.customerCard_content}>
          {courseSet.grades.split(',').join(', ')}
        </Typography>
      }
    </CourseInfoCard>
  );
}
